import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-appointment-status-tag',
  templateUrl: './appointment-status-tag.component.html',
  styleUrls: ['./appointment-status-tag.component.less']
})
export class AppointmentStatusTagComponent implements OnInit {

  backgroundColor: string = '#0078D7';
  foregroundColor: string = '#fff';
  _icon: string = '';
  text: string = '-';
  defaultText: string = '-';
  _status: number = 0;

  @Input()
  set status(s: number | null | undefined) {
    this._status = s || 0;
    this.onStatusCodeChange();
  };

  constructor() { }

  ngOnInit(): void {
  }

  onStatusCodeChange() {
    switch (this._status) {
      case 1:
        this.setStatus('CANCELADO', '#FFCCCC', '#FF0000'); // Light Red background, Red text
        break;
      case 2:
        this.setStatus('NÃO COMPARECEU', '#FFFFCC', '#FFA500'); // Light Yellow background, Orange text
        break;
      case 3:
        this.setStatus('FINALIZADO', 'rgb(30 168 2)', '#fff'); // Light Green background, Green text
        break;
      case 4:
        this.setStatus('MENSAGERIA', '#CCCCFF', '#0000FF'); // Light Blue background, Blue text
        break;
      case 5:
        this.setStatus('ERRO NA FINALIZAÇÃO', '#FF6666', '#FFF'); // Strong Red background, Red text
        break;
      case 6:
        this.setStatus('REABERTO', '#FFD580', '#FF8C00'); // Light Orange background, Orange text
        break;
      case 7:
        this.setStatus('PRÉ-AVALIAÇÃO', '#f4f4f4', '#808080'); // Light Gray background, Gray text
        break;
      case 9:
        this.setStatus('AGUARDANDO ASSINATURA', '#FFD580', '#FF8C00'); // Light Orange background, Orange text
        break;
      default:
        this.setStatus('-', '#FFFFFF', '#000000'); // White background, Black text
        break;
    }
  }

  private setStatus(text: string, bgColor: string, fgColor: string) {
    this.text = text;
    this.backgroundColor = bgColor;
    this.foregroundColor = fgColor;
  }

}
